import { render, staticRenderFns } from "./blackSign.vue?vue&type=template&id=7c1a6a5c&scoped=true"
import script from "./blackSign.vue?vue&type=script&lang=js"
export * from "./blackSign.vue?vue&type=script&lang=js"
import style0 from "./blackSign.vue?vue&type=style&index=0&id=7c1a6a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1a6a5c",
  null
  
)

export default component.exports